import { CREATE_BIKE_MODEL_REQUEST, CREATE_BIKE_MODEL_REQUEST_SUCCESS, CREATE_BIKE_MODEL_REQUEST_FAILURE } from '../constants/create_bike_model.constants';

const prefix = 'CREATE'; const
    item = 'MODEL';
export const createBikeModelRequest = params => ({
    type: CREATE_BIKE_MODEL_REQUEST, params, prefix, item,
});

export const createBikeModelRequestSuccess = payload => ({
    type: CREATE_BIKE_MODEL_REQUEST_SUCCESS, payload,
});

export const createBikeModelRequestFailure = error => ({
    type: CREATE_BIKE_MODEL_REQUEST_FAILURE, error, prefix, item,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/redux/actions/create_bike_model.actions.js